import React, { useState } from 'react';
import {setExploreToast} from 'actions/index.js';
import {connect} from 'react-redux';

const Toast = ({toast, setExploreToast}) => {
    if (!toast) {
        return (<div></div>);
    }

    return (
        <div className="toast-box">
          <div
            onClick={() => setExploreToast(undefined)}
            className="delete-button">x</div>
          {toast}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        toast: state.explore.toast
    };
};

const mapDispatchToProps = (dispatch) => ({
    setExploreToast: (t) => dispatch(setExploreToast(t))
});

export default connect(mapStateToProps, mapDispatchToProps)(Toast);
